import React, { Component } from 'react';
import {
  Loading,
  SkeletonText,
  Accordion,
  AccordionItem,
  AccordionProps,
  AccordionSkeleton,
  Tile,
  DatePicker,
  DatePickerInput,
  Button,
  DataTable,
  DataTableCell,
  Table,
  TableHeader,
  TableHead,
  TableRow,
  TableContainer,
  TableBody,
  TableCell,
  InlineLoading,
  FormGroup,
  MultiSelect,
  DropdownSkeleton
} from 'carbon-components-react';
import moment from 'moment';
import Save16 from '@carbon/icons-react/lib/save/16';
import { api, drill, me } from '../../../../helpers/api/api';
import { IsInRole } from '../../../../helpers/authorization/Policies';
import { showNotification } from '../../../../helpers/notification/BaseNotification';
import {
  getError,
  getSuccess,
  apioperation,
  entitiesLabels,
  DateFormat,
} from '../../../../helpers/Constants';
import { AppContext } from '../../../../helpers/context/AppContext';
import { IsEnabled } from '../../../../helpers/authorization/Policies';
import DrillRepository from '../../../../helpers/api/DrillRepository';
import DateTimePicker from '../../../../helpers/DateTimePicker';
import SimpleReactValidator from 'simple-react-validator';

export class DrillReportInformation extends Component {
  currentDate = moment().format('YYYY-MM-DD');
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = {
      isSubmitted: false,
      editingDisabled: false,
      drillReport: {},
      isLoadingProject: false,
      appAllWorksitePrj: null,
      projects: this.props.drillReport?.projects || [],
      dateOfOccurence: this.props.drillReport?.deliveryDate,
      isProjectsLoaded: false,
    };

    // this.onStartDateChange = this.onStartDateChange.bind(this);
    this.getAllProjects = this.getAllProjects.bind(this);
    this.updateMainInformation = this.updateMainInformation.bind(this);
    this.renderLoadingModal = this.renderLoadingModal.bind(this);
    this.getWorksitePrjFiltered = this.getWorksitePrjFiltered.bind(this);
    this.getSelectedProjects = this.getSelectedProjects.bind(this);
  }

  componentDidMount() {
    this.getAllProjects();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.drillReport?.projects !== this.props.drillReport?.projects) {
      this.setState({ projects : this.props.drillReport?.projects,
                      dateOfOccurence : this.props.drillReport?.deliveryDate == '0001-01-01T00:00:00Z'? null : this.props.drillReport?.deliveryDate,
                      isProjectsLoaded : true
      });
    }
  }

  getAllProjects = () => {
    this.setState({
      isLoadingProject: true,
    });
    api
      .getAll('/me/worksitesproject')
      .then((response) => {
        this.setState({
          appAllWorksitePrj: response.data.filter(a => a.end >= this.currentDate)
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.PROJECT, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingProject: false,
        });
      });
  };

  renderLoadingModal = () => {
    const show = this.state.isSubmitted;
    return show && <Loading active withOverlay description="Saving..." />;
  };

  getWorksitePrjFiltered() {
    if (this.props.drillReport?.drillPlan?.idWorkSite != null) {
      const data = (this.state.appAllWorksitePrj || []).filter((el) => el.idWorkSite == this.props.drillReport?.drillPlan?.idWorkSite);
      return data;
    }
    return this.state.appAllWorksitePrj;
  }

  getSelectedProjects = (listProject) => {
    console.log('SELEcted .. ', this.state.isLoadingProject, this.state.projects, this.props.drillReport);
    const drillPlanPrjs = this.props.drillReport?.projects || []

    let selectedProjects = listProject.filter(({ idProject: idProject }) => drillPlanPrjs.some(({ id: idSelected, idProject: idProjectSelected }) => idProject === idSelected || idProject === idProjectSelected))
    return selectedProjects
  };

  updateMainInformation = async () => {
    try {
      if (this.validator.allValid()) {
        this.setState({ isSubmitted: true, editingDisabled: true });

        await api.put('/drill/maininformation', {
          ...this.props.drillReport,
          projects: this.state.projects,
          drillReportProjects: this.state.projects.map(key => {
            return { IdDrillReport: this.props.drillReport?.id, IdDrillPlan: this.props.drillReport?.idDrillPlan, IdProject: key.idProject ? key.idProject : key.id };
          }),
        });

        const drillReport = this.props.drillReport;
        drillReport.projects = this.state.projects;
        drillReport.drillReportProjects = this.state.projects.map(key => {
          return { IdDrillReport: this.props.drillReport?.id, IdDrillPlan: this.props.drillReport?.idDrillPlan, IdProject: key.idProject ? key.idProject : key.id };
        })
        DrillRepository.updateCachedDrill(drillReport);
        
        showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.EMERGENCYDRILL, apioperation.PUT));
      } else {
        this.validator.showMessages();
        showNotification.warning(`${entitiesLabels.WARNING}`,
          ` ${entitiesLabels.NOTIFICATION} required fields are missing  `
        );

        this.forceUpdate();
      }
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`, getError(entitiesLabels.EMERGENCYDRILL, apioperation.PUT));
    } finally {
      this.setState({ isSubmitted: false, editingDisabled: false });
    }
  };

  updateStateDP = (inputName, inputValue, objName) => {
    var drillReport = this.props.drillReport;

    drillReport.deliveryDate = inputValue;

    this.setState({
      dateOfOccurence: drillReport.deliveryDate,
    });
    return { drillReport };
  };
  // onStartDateChange(e) {

  //  let value = e.target.value;

  //   var drillReport = this.props.drillReport;

  //   drillReport.deliveryDate = moment(e[0]).format("YYYY-MM-DD, h:mm:ss a");

  //   return { drillReport };
  // }

  renderMainInformationTitle = () => {
    return (
      <>
        {this.props.is4ASingleReport ? (
          <>
            <div className="bx--row">
              <div className="bx--col-lg-3 bx--col-md-3 mainInformationReportAccordion">
                <span className="mainInformationHeaderTitle">General Information</span>
              </div>
            </div>
          </>
        ) : (
          ''
        )}

        <div className="bx--row">
          <div className="bx--col-lg-3 bx--col-md-2 mainInformationPadding">
            {/* RITM0945977 */}
            {/* <span className="bold">Division</span> */}
            <span className="bold">Business Line</span>
            <div className="bx--row">
              <div className="bx--col-lg-12 bx--col-md-12 mainInformationPadding">
                {this.props.tabsLoading ? (
                  <SkeletonText />
                ) : (
                  <span className="font-small">{this.props.drillReport?.division?.name}</span>
                )}
              </div>
            </div>
          </div>
          <div className="bx--col-lg-5 bx--col-md-3 mainInformationPadding main-information-detail">
            <span className="bold">WorkSite</span>
            <div className="bx--row">
              <div className="bx--col-lg-12 bx--col-md-12 mainInformationPadding">
                {this.props.tabsLoading ? (
                  <SkeletonText />
                ) : (
                  <span className="font-small">{this.props.drillReport?.workSite?.name}</span>
                )}
              </div>
            </div>
          </div>
          <div className="bx--col-lg-4 bx--col-md-3 mainInformationPadding">
            <span className="bold">Drill Type</span>
            <div className="bx--row">
              <div className="bx--col-lg-12 bx--col-md-12 mainInformationPadding">
                {this.props.tabsLoading ? (
                  <SkeletonText />
                ) : (
                  <span className="font-small">{this.props.drillReport?.drillType?.name}</span>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  render() {
    const listProject = this.props.drillReport?.drillPlan?.idWorkSite
      ? this.getWorksitePrjFiltered()
      : [];
    const validations = {
      date: this.validator.message('dateOfOccurence', this.state.dateOfOccurence, 'required'),
      project: this.validator.message('project',  this.state.projects != undefined && this.state.projects != [] ? this.state.projects[0] : false, 'required'), //Framework upgrade from 2.2 to 8.0
    };

    return this.props.drillReport ? (
      <AppContext.Consumer>
        {({ user }) =>
          IsEnabled(user, 'Emergency Drill') ? (
            <>
              {this.state.mainInformationOpened ? (
                <span className="mainInformationHeaderTitleExpanded">General Informations</span>
              ) : (
                <div>
                  {this.renderLoadingModal()}
                  <Accordion>
                    <AccordionItem 
                      open = {this.props.is4ASingleReport}
                      onHeadingClick={this.onMainInformationAccordionClick}
                      className="mainInformationTitle"
                      title={this.renderMainInformationTitle(this.props.drillReport)}
                    >
                      {!this.props.tabsLoading ? (
                        <>
                          {this.props.is4ASingleReport &&
                            (<Tile className="mainInformation--tile">
                              <div className="bx--row">
                                <div className="bx--col-lg-2 bx--col-md-2">Drill Report Code</div>
                                <div className="bx--col-lg-10 bx--col-md-6">
                                  {this.props.drillReport?.drillReportCode}
                                </div>
                              </div>
                            </Tile>)
                          }
                          <Tile className="mainInformation--tile">
                            <div className="bx--row">
                              <div className="bx--col-lg-2 bx--col-md-2">Company</div>
                              <div className="bx--col-lg-10 bx--col-md-6">
                                {this.props.drillReport?.company?.name}
                              </div>
                            </div>
                          </Tile>
                          <Tile className="mainInformation--tile">
                            <div className="bx--row">
                              <div className="bx--col-lg-2 bx--col-md-2">Projects {this.props.is4ASingleReport? "*" : '' }</div>
                              <div className="bx--col-lg-10 bx--col-md-6">
                                {!this.props.is4ASingleReport ?
                                  this.props.drillReport?.drillPlan?.projects?.map((x) => x?.name).join(',') :
                                  <FormGroup className="bx--col--md-6 bx--col-lg-6">
                                    {
                                      this.state.isLoadingProject || !this.state.isProjectsLoaded ? (
                                        <DropdownSkeleton />
                                      ) : (
                                        <MultiSelect
                                          id="idProject"
                                          placeholder="Select Projects"
                                          name="projects"
                                          items={listProject}
                                          itemToString={(item) => (item ? item.project : '')}
                                          initialSelectedItems={
                                            this.getSelectedProjects(listProject)
                                          }
                                          onChange={(prjs) => {
                                              this.setState({ projects: prjs.selectedItems || [] })
                                              const drillReport = this.props.drillReport;
                                              drillReport.projects = prjs.selectedItems;
                                              drillReport.drillReportProjects = prjs.selectedItems.map(key => {
                                                return { IdDrillReport: this.props.drillReport?.id, IdDrillPlan: this.props.drillReport?.idDrillPlan, IdProject: key.idProject ? key.idProject : key.id };
                                                })
                                            }
                                          }
                                          selectionFeedback="top-after-reopen"
                                          disabled={this.props.disabled || this.props.isSendedNotification}
                                          invalid={validations.project != null}
                                        />
                                      )}
                                      {this.state.isProjectsLoaded && this.props.isSendedNotification ?
                                          <p className='p-dproj'>{(this.state.projects.map(item => item.name ? item.name : item.project).sort()).join(", ")}</p>
                                          : null
                                      }
                                    {validations.project}
                                  </FormGroup>
                                }

                              </div>
                            </div>
                          </Tile>
                          <Tile className="mainInformation--tile">
                            <div className="bx--row">
                              <div className="bx--col-lg-2 bx--col-md-2">Drill Type Detail</div>
                              <div className="bx--col-lg-10 bx--col-md-6">
                                {this.props.drillReport?.drillTypeDetail?.name}
                              </div>
                            </div>
                          </Tile>
                          <Tile className="mainInformation--tile">
                            <div className="bx--row">
                              <div className="bx--col-lg-2 bx--col-md-2">Participant</div>
                              <div className="bx--col-lg-10 bx--col-md-6">
                                {this.props.drillReport?.participant?.name}
                              </div>
                            </div>
                          </Tile>
                          {this.props.is4ASingleReport ? (
                            <>
                              <Tile className="mainInformation--tile">
                                <div className="bx--row">
                                  <div className="bx--col-lg-2 bx--col-md-2">Planned Week</div>
                                  <div className="bx--col-lg-10 bx--col-md-6">
                                    {this.props.drillReport?.plannedWeekWithDate}
                                  </div>
                                </div>
                              </Tile>
                              <Tile className="mainInformation--tile">
                                <div className="bx--row">
                                  <div className="bx--col-lg-2 bx--col-md-2">
                                    Date of DRILL Execution*
                                  </div>
                                  <FormGroup className="bx--col--md-6 bx--col-lg-6">
                                    <DateTimePicker
                                      value={
                                        this.state.dateOfOccurence != null &&
                                          this.state.dateOfOccurence != '0001-01-01T00:00:00Z'
                                          ? this.state.dateOfOccurence
                                          /*: this.props.drillReport.deliveryDate != null &&
                                            this.props.drillReport.deliveryDate !=
                                            '0001-01-01T00:00:00Z'
                                            ? this.props.drillReport.deliveryDate*/
                                            : 'DD/MM/YYYY hh:mm AM/PM'
                                      }
                                      type="datetime"
                                      placeholder="DD/MM/YYYY hh:mm AM/PM"
                                      name="deliveryDate"
                                      alt="props.drillReport"
                                      onChange={this.updateStateDP}
                                      disabled={this.props.disabled}
                                      invalid={validations.date}
                                    />
                                    {validations.date}
                                  </FormGroup>
                                  {/* <DatePicker
                                      dateFormat="d/m/Y"
                                      datePickerType="single"
                                      id="date-picker"
                                      light
                                      locale="en"
                                      short={false}
                                      onChange={this.onStartDateChange}
                                      type="datetime"
                                      placeholder="DD/MM/YYYY hh:mm AM/PM"
                                    >
                                      <DatePickerInput
                                        id="date-picker-input-startDate"
                                        labelText="Date"
                                        value={
                                          this.props.drillReport?.deliveryDate
                                          && this.props.drillReport?.deliveryDate != "0001-01-01T00:00:00Z"
                                            ? moment(
                                                this.props.drillReport
                                                  ?.deliveryDate
                                              ).format("DD/MM/YYYY")
                                            : DateFormat
                                        }
                                        iconDescription="Delivery Date"
                                        disabled={this.props.disabled}
                                        type="datetime"
                                        placeholder="DD/MM/YYYY hh:mm AM/PM"
                                      />
                                    </DatePicker> */}
                                </div>
                                {!this.props.disabled ? (
                                  <div className="bx--row">
                                    {(IsInRole(user, 'Administrator') ||
                                      IsInRole(user, 'Compiler') || IsInRole(user, 'Data Approver')) && ( //RITM1064131
                                        <div className="bx--col-lg-12 bx--col-md-12 main-information-button">
                                          <Button
                                            size="default"
                                            renderIcon={Save16}
                                            kind="primary"
                                            onClick={this.updateMainInformation}
                                            disabled={this.props.disabled}
                                          >
                                            Save
                                          </Button>
                                        </div>
                                      )}
                                  </div>
                                ) : (
                                  ''
                                )}
                              </Tile>
                            </>
                          ) : (
                            <>
                              <Tile className="mainInformation--tile">
                                <div className="bx--row">
                                  <div className="bx--col-lg-2 bx--col-md-2">Planned Year</div>
                                  <div className="bx--col-lg-10 bx--col-md-6">
                                    {this.props.drillReport?.referenceYear}
                                  </div>
                                </div>
                              </Tile>
                            </>
                          )}
                        </>
                      ) : (
                        <SkeletonText />
                      )}
                    </AccordionItem>
                  </Accordion>
                </div>
              )}
            </>
          ) : (
            ''
          )
        }
      </AppContext.Consumer>
    ) : (
      <></>
    );
  }
}
